import { Store, Users, Drama } from 'lucide-react';
/** Métadonnées d'affichage par type de fiche (label, icône, couleur). Source unique. */
export const DIRECTORY_TYPE_META = {
    commercant: { label: 'Commerçant', labelPlural: 'Commerçants', icon: Store, color: 'text-emerald-500' },
    association: { label: 'Association', labelPlural: 'Associations', icon: Users, color: 'text-indigo-500' },
    lieu_culturel: { label: 'Lieu culturel', labelPlural: 'Lieux culturels', icon: Drama, color: 'text-amber-500' },
};
export const DIRECTORY_TYPES = Object.keys(DIRECTORY_TYPE_META);
